<template>
  <div class="duty-management" v-if="teacherDutyData.length">
    <table class="custom-table">
      <thead>
        <tr>
          <th v-for="(header, index) in teacherDutyData[0]" :key="index">
            {{ header }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, rowIndex) in teacherDutyData.slice(
    1,
    teacherDutyData.length - 1
  )" :key="rowIndex">
          <td v-for="(item, index) in row" :key="index" v-html="item" v-if="typeof item == 'string'"></td>
          <td v-for="(item, index) in row" :key="index" v-if="typeof item == 'object'">
            <el-select v-if="editStatus" v-model="item[0].teacherIds" multiple filterable allow-create
              default-first-option placeholder="请选择" class="teacher-select" @change="teacherChange($event, item)">
              <el-option v-for="teacherInfo in teacherList" :key="teacherInfo.id" :label="teacherInfo.teacherName"
                :value="teacherInfo.id">
              </el-option>
            </el-select>
            <div class="teacher-info" v-for="(itemT, indexT) in item" :key="indexT">
              <el-popover placement="right" width="400" trigger="click">
                <el-table :data="item">
                  <el-table-column width="100" property="teacherName" label="教师"></el-table-column>
                  <el-table-column width="150" property="teacherPhone" label="电话">
                    <template slot-scope="scope">
                      <el-input :disabled="!editStatus" v-model="scope.row.teacherPhone" placeholder="未设置" />
                      <!-- <span>{{ scope.row.teacherPhone ? scope.row.teacherPhone : '无' }}</span> -->
                    </template>
                  </el-table-column>
                  <el-table-column property="location" label="管理区域">
                    <template slot-scope="scope">
                      <el-input :disabled="!editStatus" v-model="scope.row.location" placeholder="未设置" />
                      <!-- <span>{{ scope.row.location ? scope.row.location : '无' }}</span> -->
                    </template>
                  </el-table-column>
                </el-table>
                <el-button slot="reference" type="text"> <span v-if="itemT.location">{{ itemT.location }}：</span>
                  {{ itemT.teacherName }}</el-button>
              </el-popover>
            </div>
          </td>
        </tr>
        <!-- 最后一行说明 -->
        <tr>
          <td colspan="1" width="100">说明</td>
          <!-- 标题占据一列 -->
          <td class="notes" :colspan="teacherDutyData[0].length - 1" style="text-align: left"
            v-html="teacherDutyData[teacherDutyData.length - 1][1]"></td>
        </tr>
      </tbody>
    </table>
    <div class="btns">
      <div class="btn" @click="submit">
        {{ editStatus ? "完成" : "编辑" }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  props: {
    // 教师值日列表数据
    teacherDutyData: {
      type: Array,
      default: [],
    },
    // 教师列表
    teacherList: {
      type: Array,
      default: [],
    },
    // 当前值日信息
    dutyInfo: {
      type: Object,
    },
    // 日期列表
    dateList: {
      type: Array,
    },
    // 是否编辑状态
    editStatus: {
      type: Boolean,
    },
    // 值日类型列表
    dutyTypeList: {
      type: Array,
    },
  },
  // 刷新列表
  inject: ["refresh"],
  methods: {
    // 教师切换时将item中的教师数据与切换后的teacherIds列表进行同步
    teacherChange(e, item) {
      if (!e.length) {
        // 如果切换后教师列表为空时，将item列表也设置为空，并重新添加一个对象，里面包含teacherIds,否则选择框没有可绑定数据会报错
        item.length = 0;
        item.push({
          teacherIds: [],
        });
        return;
      }
      // 同步数据操作
      item.forEach((itemF, indexF) => {
        if (
          itemF.teacherName &&
          !e.find((itemE) => itemE == itemF.teacherName) &&
          !e.find((itemE) => itemE == itemF.teacherId)
        ) {
          item.splice(indexF, 1);
        }
      });
    },
    // 确认编排
    submit() {
      // 如果当前编辑状态为false，则返回编辑状态为true的信号
      if (!this.editStatus) return this.$emit("editStatusChange", true);
      // 定义一个提交列表
      let submitList = [];

      // 遍历teacherDutyData数组
      this.teacherDutyData.forEach((item) => {
        // 遍历item数组
        item.forEach((itemF) => {
          // 如果itemF是对象
          if (typeof itemF === "object") {
            // 如果itemF[0].teacherIds数组长度为0，则返回
            if (!itemF[0].teacherIds.length) return;

            // 遍历itemF[0].teacherIds数组
            itemF[0].teacherIds.forEach((itemT) => {
              // 在teacherList数组中查找id为itemT的教师信息
              let teacherInfo = this.teacherList.find(
                (itemE) => itemE.id === itemT
              );
              // 如果教师信息存在，且itemF数组中没有id为teacherInfo.id的元素
              if (
                teacherInfo &&
                !itemF.find((itemO) => itemO.teacherId == teacherInfo.id)
              ) {
                // 将教师信息添加到itemF数组中
                itemF.push({
                  teacherIds: [],
                  // dutyTime: this.dateList[item.indexOf(itemF) - 1], // 检索日期列表中与表格数据对应列数下标的日期
                  dutyWeek: item.indexOf(itemF) == 1 ? 7 : item.indexOf(itemF) - 1,
                  location: "",
                  dutyType:
                    "" +
                    this.dutyTypeList.find((itemD) => itemD.typeName == item[0])
                      .id, // 检索值日类型中与行头相同的值日类型的id
                  dutyId: this.dutyInfo.id,
                  teacherId: teacherInfo.id,
                  teacherName: teacherInfo.teacherName,
                  teacherPhone: teacherInfo.phone,
                });
                // 如果教师信息是字符串，且itemF数组中没有名为itemT的元素
              } else if (
                typeof itemT == "string" &&
                !itemF.find((teacherName) => teacherName == itemT)
              ) {
                // 将教师信息添加到itemF数组中
                itemF.push({
                  teacherIds: [],
                  // dutyTime: this.dateList[item.indexOf(itemF) - 1], // 检索日期列表中与表格数据对应列数下标的日期
                  dutyWeek: item.indexOf(itemF) == 1 ? 7 : item.indexOf(itemF) - 1,
                  location: "",
                  dutyType:
                    "" +
                    this.dutyTypeList.find((itemD) => itemD.typeName == item[0])
                      .id, // 检索值日类型中与行头相同的值日类型的id
                  dutyId: this.dutyInfo.id,
                  teacherName: itemT,
                  teacherId: null,
                  teacherPhone: null,
                });
              }
            });
          }
        });
      });

      // 遍历teacherDutyData数组
      this.teacherDutyData.forEach((item) => {
        // 遍历item数组
        item.forEach((itemF) => {
          // 如果itemF是对象，并且长度大于1，且不包含teacherId属性，则将其shift()出数组
          if (
            typeof itemF === "object" &&
            itemF.length > 1 &&
            !("teacherId" in itemF[0])
          ) {
            itemF.shift();
          }
          // 如果itemF是对象，则遍历itemF数组
          if (typeof itemF === "object") {
            itemF.forEach((itemM) => {
              // 检测是否有teacherName属性并且teacherIds是否包含该数据
              if (
                "teacherName" in itemM 
                // && !submitList.find(
                //   (subItem) =>
                //     subItem.teacherName == itemM.teacherName &&
                //     subItem.dutyType == itemM.dutyType &&
                //     subItem.dutyTime == itemM.dutyTime
                // )
              ) {
                submitList.push(itemM);
              }
            });
          }
        });
      });
      // console.log("this.teacherDutyData:", this.teacherDutyData);
      // console.log("submitList:", submitList);

      // 调用put方法，向服务器发送更新教师duty的请求
      this.put(this.$url.updateDutyTeacher, submitList).then((res) => {
        // 如果返回的代码不是200，则提示修改失败
        if (res.code !== 200) return this.$message.error(res.msg);
        // 如果返回的代码是200，则提示修改成功
        this.$message.success(res.msg);
        // 修改编辑状态的值，并触发dialogClose事件和refresh事件
        this.$emit("editStatusChange", false);
        this.$emit("dialogClose");
        this.refresh();
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "./dutyManagement.scss";
</style>
